export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11020.35c122fd.jpg";